//flow
import styled from 'styled-components';

import { themes } from 'kb-shared';
import { typography } from '../../../styled';

export const { colors } = themes;
export const {
  sans: {
    copy: { Nano }
  },
  spans: { Bold }
} = typography;

export const DiscountBase = styled(Nano)`
  background: ${colors.KBPale};
  display: inline-block;
  padding: 4px 8px;
  margin-bottom: 0;
`;

export const CardSelectionHighlightBase = styled.div`
  background: ${colors.KBYellow};
  position: relative;
  transition: all 0.2s;
  z-index: 1;
`;

export const MemberPricing = styled(DiscountBase)`
  margin-top: 10px;
`;
